import { FunctionComponent, ReactElement } from "react";
import { Button } from "@chakra-ui/react";

import { size } from "src/types/size";

type ButtonVariantProps =
  | "primary"
  | "secondary"
  | "outline"
  | "tertiary"
  | "danger"
  | "link"
  | "dark"
  | "ghost"
  | "offset";

type Props = {
  label: string;
  size?: size;
  variant?: ButtonVariantProps;
  colorScheme?: string;
  bg?: string;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
  loadingText?: string;
  isLoading?: boolean;
  spinner?: ReactElement;
  spinnerPlacement?: "start" | "end";
  color?: string;
  borderRadius?: string | number;
  padding?: string | number;
  handleClick?: () => void;
  width?: string;
  isDisabled?: boolean;
  border?: string | number;
};

export const CustomButton: FunctionComponent<Props> = ({
  label,
  colorScheme,
  size,
  variant,
  leftIcon,
  rightIcon,
  isLoading,
  loadingText,
  spinner,
  spinnerPlacement,
  color,
  bg,
  borderRadius,
  padding,
  handleClick,
  width,
  isDisabled,
  border,
}) => {
  return (
    <Button
      colorScheme={colorScheme}
      color={color}
      size={size}
      variant={variant}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      isLoading={isLoading}
      loadingText={loadingText}
      isDisabled={isDisabled}
      spinner={spinner}
      spinnerPlacement={spinnerPlacement}
      bg={bg}
      borderRadius={borderRadius}
      padding={padding}
      onClick={handleClick}
      width={width}
      border={border}
    >
      {label}
    </Button>
  );
};
